import { getTerms } from "@/api/terms";
import router from "@/router";

export default {
  async getTerms(
    { commit, state },
    {
      propertyId = router.currentRoute.query.property,
      lang = router.currentRoute.query.lang,
    }
  ) {
    // Verify if the cookies and the query language match
    // If they match, the query language is used. Otherwise, the cookie language is applied
    let cookiesLanguage = router.app.$cookies.get("lang-key");
    if (cookiesLanguage && cookiesLanguage != lang) {
      lang = cookiesLanguage;
    }
    // cache when language of terms does not change
    if (lang !== state.termsLang && state.status !== "fetching") {
      commit("SET_LOADING", true, { root: true });
      commit("REQUEST_TERMS");
      try {
        commit("SET_LOADING", false, { root: true });
        const payload = await getTerms({ propertyId, lang });
        commit("SUCCESS_REQUEST_TERMS", { payload, lang });
      } catch (e) {
        commit("SET_LOADING", false, { root: true });
        commit("FAILURE_REQUEST_TERMS");
      }
    }
  },
};
